<template>
  <div class="home">
    <div class="liveB">
      <div class="entTime" v-show="isStarTime">
        <img :src="picture">
      </div>
      <div class="entTime" v-show="isEndTime">
        <img :src="picture">
        <div class="cover-over">
          <span>{{liveStr}}</span>
        </div>
      </div>
      <div class="entTime" v-show="isStartTime">
        <img :src="picture">
        <div class="cover-over">
          <van-loading size="24px">等待重新连接中...</van-loading>
        </div>
      </div>
      <div class="videobox">
        <div class="prism-player" id="player-con" v-show="isVideo1"></div>
      </div>
    </div>
    <div class="live-personal-info" v-if="liveStatus!==3">
      <div class="personal-info-img warp" v-if="liveStatus==4">
        <strong>直播结束</strong>
      </div>
      <div class="personal-info-img warp" v-if="liveStatus==2">
        <strong>直播倒计时</strong>
      </div>
      <div class="personal-info-img warp" v-else-if="liveStatus==1">
        <img :src="anchorAvatar">
        <span>{{anchorName}}</span>
      </div>
      <div class="personal-info-time">
        <div class="info-time-text">
          <img v-if="liveStatus==1" src="../../assets/liveimg/dynamic.png">
          <span v-if="liveStatus==1">已直播{{timesped}}</span>
          <span v-else-if="liveStatus==2">{{timesped1}}</span>
          <span v-else-if="liveStatus==4">等待上传视频</span>
        </div>
        <div v-if="liveStatus==1" class="info-time-num">{{watchNum}}累计人次</div>
      </div>
    </div>
    <van-tabs v-model="active">
      <van-tab title="详情">
        <div class="live-details">
          <div class="live-details-button">
            <div class="msgbox-botton" v-if="openPopup == true">
              <span>打开中科名兽医APP,<strong>与专家“零距离”互动</strong></span>
              <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
                <script type="text/wxtag-template">
                  <style>.btn {height: 45px;}</style>
                  <div class="btn">打开APP</div>
                </script>
              </wx-open-launch-app>
            </div>
            <div v-else class="app-button" @click="openApp">打开中科名兽医APP，与专家“零距离”互动</div>
          </div>
          <div class="live-details-title">{{liveTitle}}</div>
          <div class="live-details-info">
            <div class="details-info-img">
              <img :src="anchorAvatar">
            </div>
            <div class="details-info-text">
              <div class="info-text-name">{{anchorName}}</div>
              <div class="info-text-list">{{anchorTitle}}</div>
            </div>
            <div class="details-info-button">
              <div class="follow-msgbox-botton" v-if="openPopup == true">
                <span>+ 关注</span>
                <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
                  <script type="text/wxtag-template">
                    <style>.btn {height: 45px;}</style>
                    <div class="btn">打开APP</div>
                  </script>
                </wx-open-launch-app>
              </div>
              <div v-else class="follow-button" @click="openApp">+ 关注</div>
            </div>
          </div>
          <div class="live-details-notice">直播公告</div>
          <div class="live-details-account">
            <img src="../../assets/liveimg/notice.png" alt="">
            <span>课程简介</span>
          </div>
          <div class="live-details-content">
            <p v-html="liveDesc"></p>
            <div class="roomdescimg" v-for="(item,i) in descImgList" :key="i">
              <img :src="item">
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="分享榜单">
        <div class="share-billboard">
          <div class="live-details-button">
            <div class="msgbox-botton" v-if="openPopup == true">
              <span>打开中科名兽医APP,<strong>与专家“零距离”互动</strong></span>
              <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
                <script type="text/wxtag-template">
                  <style>.btn {height: 45px;}</style>
                  <div class="btn">打开APP</div>
                </script>
              </wx-open-launch-app>
            </div>
            <div v-else class="app-button">打开中科名兽医APP，与专家“零距离”互动</div>
          </div>
          <div class="share-billboard-list" v-if="liveShareList.length>0">

            <div class="share-billboard-box" v-for="(item,i) in liveShareList" :key="i">
              <div class="billboard-box-img">
                <img v-if="i==0" src="../../assets/liveimg/one.png" alt="">
                <img v-if="i==1" src="../../assets/liveimg/two.png" alt="">
                <img v-if="i==2" src="../../assets/liveimg/three.png" alt="">
                <span v-if="i>2">{{i < 9 ? '0'+(i+1):(i+1)}}</span>
              </div>
              <div class="billboard-box-info">
                <div class="box-info-img">
                  <img :src="item.imgUri" alt="">
                </div>
                <div class="box-info-text">
                  <div class="info-text-title">
                    <span>{{item.userName}}</span>
                    <img v-if="item.roleId == 2" src="../../assets/liveimg/authentication.png" alt="">
                  </div>
                  <div class="info-text-region">全国区域</div>
                </div>
              </div>
              <div class="billboard-box-text">分享成功{{item.num}}人</div>
            </div>

          </div>
          <div class="share-billboard-empty" v-else>
            <img src="../../assets/liveimg/empty.png" alt="">
          </div>
        </div>
      </van-tab>
    </van-tabs>


    <van-overlay :show="showLogin">
      <div class="wrapper" @click.stop>
        <div class="showlogin">
          <div class="login-title">用户登录</div>
          <div class="login-box">
            <van-field type="tel" v-model="phone" label="手机号" placeholder="请输入手机号"/>
          </div>
          <div class="login-box">
            <van-field type="number" v-model="code" center clearable label="验证码" maxlength="6" @input="code.length>6?code:code.slice(0,6)" placeholder="请输入短信验证码">
              <template #button>
                <van-button size="small" type="primary" :disabled="disabled" @click="sendVerifcode">{{telstr}}</van-button>
              </template>
            </van-field>
          </div>
          <div class="login-button" @click="submit">登 录</div>
        </div>
      </div>
    </van-overlay>

  </div>
</template>

<script>
  import VueAliplayer from 'vue-aliplayer'
  import { wechaturl } from '@/api/path.js'
  import { iswx, wxshare, disposeTime, disposeTime1 } from '@/utils/utils.js'
  import { getUserSendCode, getUserInfo, zkmsyPhonelogin, tokenlogin, getLiveDetail, getLiveShareInc, getLiveShareList, getLiveStatus } from '@/api/resetApi.js'

  export default {
    name: 'liveBroadcast',
    components: {
      'ali-player': VueAliplayer
    },
    inject: ['reload'],
    data(){
      return{
        showLogin: true,
        disabled: false,
        count: 60,
        timer: '',
        code: '',
        phone: '',
        telstr: '获取验证码',
        userId: '',
        token: '',
        url: '',

        numRefresh: 1,
        numLive: 1,
        active: 0,
        ip: '',
        isLive: true,
        rePlay: false,
        roomId: '',
        share_user_id: '',
        isVideo1: true,
        isEndTime: false,
        isStarTime: false,
        isStartTime: false,
        picurl: '',
        timePlayUri: '',
        player: null,
        liveTime: '',
        picture: '',
        liveStr: '',
        giveTimer1: null,
        giveTimer2: null,
        giveTimer3: null,
        liveData: [],
        urlimg: require('../../assets/liveimg/user.png'),
        anchorAvatar: '',
        anchorName: '',
        anchorTitle: '',
        liveTitle: '',
        coverImg: '',
        liveBeginTime: '',
        liveEndTime: '',
        actualStartTime: '',
        liveDesc: '',
        liveDescImg: '',
        liveIntro: '',
        shareImg: '',
        watchNum: '',
        likeNum: '',
        addWatermark: '',
        videoDuration: '',
        playbackUrl: '',
        videoDuration: '',
        adminUserIds: '',
        rtmpLive: '',
        httpLive: '',
        forenoticeImg: '',
        forenoticeVideo: '',
        liveStatus: '',
        descImgList: [],
        liveShareList: [],
        chatTimer: null,
        timesped: '',
        chatTimer1: null,
        timesped1: '',
        openPopup: false,
        id: 'wxopenLanchAppId',
        appid: 'wxdc89dd9a7329fe47',
        wechatOpenAppData: '',
        skinLayoutA: [{name: "bigPlayButton", align: "blabs", x: 0, y: 80}],
        skinLayoutB: [
          {name: "bigPlayButton", align: "blabs", x: 0, y: 80},
          {name: "H5Loading", align: "cc"},
          {name: "errorDisplay", align: "tlabs", x: 0, y: 0},
          {name: "infoDisplay"},
          {name:"tooltip", align:"blabs",x: 0, y: 56},
          {name: "thumbnail"},
          {
            name: "controlBar", align: "blabs", x: 0, y: 0,
            children: [
              {name: "progress", align: "blabs", x: 0, y: 44},
              {name: "playButton", align: "tl", x: 15, y: 12},
              {name: "timeDisplay", align: "tl", x: 10, y: 7},
              {name: "fullScreenButton", align: "tr", x: 10, y: 12},
              // {name:"subtitle", align:"tr",x:15, y:12},
              // {name:"setting", align:"tr",x:15, y:12},
              // {name: "volume", align: "tr", x: 5, y: 10}
            ]
          }
        ],
      }
    },
    created(){
      this.roomId = this.$route.query.roomId
      this.share_user_id = this.$route.query.share_user_id
      // this.ip = returnCitySN['cip']
      console.log('url',this.url)
      if (localStorage.getItem('uToken')) {
        this.userId = localStorage.getItem('userId')
        this.showLogin = false
        this.url = wechaturl + 'liveBroadcast?share_user_id='+this.userId+'&roomId='+this.roomId
        this.getLiveShareInc(this.userId)
      } else {
        this.showLogin = true
      }

      let json = {
        "type": "live",
        "linkId": this.roomId
      }
      this.wechatOpenAppData = JSON.stringify(json)
      if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        console.log('wechat',wechat)
        let judgewechat = wechat[1].split('.')
        // this.text = judgewechat
        if (judgewechat[0]>=8) {
          this.openPopup = true
        } else if(judgewechat[0]>=7){
          if(judgewechat[1]>=0){
              this.text = judgewechat
            if(judgewechat[2]>=12){
              this.openPopup = true
              console.log("当前符合 h5 打开指定app")
            }
          }
        }
      }

      this.shareVideoInfo()
      this.getLiveShareList()
      // this.getLiveShareInc()
    },
    mounted() {
      // 检测断网
      window.addEventListener("offline", () => {
        console.log("已断网");
        this.isEndTime = true;
        this.isStarTime = false
        this.isVideo1 = false;
        this.picture = this.coverImg;
        this.liveStr = '断网，请重新连接网络...'
      });
      window.addEventListener("online", () => {
        console.log("网络已连接");
        this.reload()
      });
      if (this.openPopup == true) {
        var btn = document.getElementById(this.id)
        btn.addEventListener('launch', e => {
          console.log('success');
        });
        btn.addEventListener('error',  e => {
          this.text = e.detail.errMsg
          if (e.detail.errMsg == 'launch:fail') {
            window.location = 'http://t.cn/Aijv8II4'
          } else {
            this.$createToast({
              txt: e.detail,
              type: 'error'
            }).show()
          }
        });
      }
      document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
    },
    methods: {
      // 获取直播信息
      async shareVideoInfo() {
        let that = this
        let data = {
          roomId: that.roomId,
        }
        const res = await getLiveDetail(data)
        console.log(res)
        try {
          if (res.data.code === 200) {
            let reg = new RegExp("\n", "g");
            that.liveData = res.data.data
            that.anchorAvatar = that.liveData.anchorAvatar?that.liveData.anchorAvatar:that.urlimg
            that.anchorName = that.liveData.anchorName?that.liveData.anchorName:''
            that.anchorTitle = that.liveData.anchorTitle?that.liveData.anchorTitle:''
            that.liveTitle = that.liveData.liveTitle?that.liveData.liveTitle:''
            that.coverImg = that.liveData.coverImg?that.liveData.coverImg:''
            that.liveBeginTime = that.liveData.liveBeginTime?that.liveData.liveBeginTime:''
            that.liveEndTime = that.liveData.liveEndTime?that.liveData.liveEndTime:''
            that.liveDesc = that.liveData.liveDesc?that.liveData.liveDesc.replace(reg, "<br/>"):''
            that.liveDescImg = that.liveData.liveDescImg?that.liveData.liveDescImg:''
            that.liveIntro = that.liveData.liveIntro?that.liveData.liveIntro:''
            that.shareImg = that.liveData.shareImg?that.liveData.shareImg:''
            that.watchNum = that.liveData.watchNum?that.liveData.watchNum:0
            that.likeNum = that.liveData.likeNum?that.liveData.likeNum:''
            that.addWatermark = that.liveData.addWatermark?that.liveData.addWatermark:''
            that.videoDuration = that.liveData.videoDuration?that.liveData.videoDuration:''
            that.playbackUrl = that.liveData.playbackUrl?that.liveData.playbackUrl:''
            that.adminUserIds = that.liveData.adminUserIds?that.liveData.adminUserIds:''
            that.rtmpLive = that.liveData.rtmpLive?that.liveData.rtmpLive:''
            that.httpLive = that.liveData.httpLive?that.liveData.httpLive:''
            that.forenoticeImg = that.liveData.forenoticeImg?that.liveData.forenoticeImg:''
            that.forenoticeVideo = that.liveData.forenoticeVideo?that.liveData.forenoticeVideo:''
            that.liveStatus = that.liveData.liveStatus?that.liveData.liveStatus:''
            // that.liveStatus = 1
            that.actualStartTime = that.liveData.actualStartTime?that.liveData.actualStartTime:''
            if (that.liveDescImg) {
              that.descImgList = that.liveDescImg.split(',')
            }
            if (that.liveStatus == 1) {
              window.clearInterval(that.chatTimer1);
              that.timesped = disposeTime(that.actualStartTime.replace(/-/g, "/"))
              that.chatTimer = window.setInterval(function () {
                that.timesped = disposeTime(that.actualStartTime.replace(/-/g, "/"))
              }, 60000)
            } else if (that.liveStatus == 2) {
              window.clearInterval(that.chatTimer);
              that.timesped1 = disposeTime1(that.liveBeginTime.replace(/-/g, "/"))
              that.chatTimer1 = window.setInterval(function () {
                that.timesped1 = disposeTime1(that.liveBeginTime.replace(/-/g, "/"))
              }, 60000)
            } else if (that.liveStatus == 3) {
              that.isLive = false
              that.rePlay = true
              window.clearInterval(that.chatTimer);
              window.clearInterval(that.chatTimer1);
            } else {
              window.clearInterval(that.chatTimer);
              window.clearInterval(that.chatTimer1);
            }
            console.log('that.liveStatus',that.liveStatus)
            let videodesc = '授课人：'+that.anchorName+'(' + that.anchorTitle + ')\r\n直播时间：'+that.liveBeginTime
            wxshare(that.shareImg,that.liveTitle,videodesc,that.url);
            that.getLiveSort(that.liveStatus)
          } else {
            that.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // 获取分享列表
      async getLiveShareList() {
        let data = {
          roomId: this.roomId
        }
        const res = await getLiveShareList(data)
        console.log(res)
        try {
          if (res.data.code == 200) {
            this.liveShareList = res.data.data
          }
        } catch (error) {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      },
      // 统计分享次数
      async getLiveShareInc(userId) {
        // console.log('统计分享次数')
        let data = {
          roomId: this.roomId,
          userId: userId,
          shareUserId: this.share_user_id,
          ip: this.ip,
        }
        const res = await getLiveShareInc(data)
        console.log(res)
        try {
          if (res.data.code == 200) {
            // this.liveShareList = res.data.data
            console.log('统计分享次数')
          }
        } catch (error) {
          this.$createToast({
            txt: res.data.msg,
            type: 'error'
          }).show()
        }
      },
      // 播放直播
      livePlayer() {
        let that = this
        let skinLayout
        if (that.isLive) {
          skinLayout = that.skinLayoutA
        } else {
          skinLayout = that.skinLayoutB
        }
        console.log('that.picurl',that.picurl)
        that.player = new Aliplayer({
          "id": 'player-con',
          "source": that.timePlayUri,
          'cover': that.picurl,
          "width": "100%",
          "height": "100%",
          "autoplay": false,
          "isLive": that.isLive,
          "rePlay": that.rePlay,
          "playsinline": true,
          "preload": true,
          disableSeek: true,
          "skinLayout": skinLayout,
          // "controlBarVisibility": "hover",
          "controlBarVisibility":"always",
          "useH5Prism": true
        },function(player){
          let u = navigator.userAgent;
          let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          player.on('liveStreamStop',function(){
            console.log('直播失败')
            if (that.numLive == 1) {
              that.getCutoff(that)
            }
            that.numLive++
          })
          if (isIOS) {
            player.on('canplaythrough',function  (e) {
              // let num1 = parseInt(that.liveTime)
              // player.seek(num1)
              player.play()
            });
          } else {
            // let num = parseInt(that.liveTime)
            // player.seek(num)
            player.play()
          }
        });
      },
      // 直播断流
      getCutoff(that) {
        that.isEndTime = true;
        that.isVideo1 = false;
        that.picture = that.coverImg;
        that.liveStr = '网路不好请刷新页面重新连接...'
        console.log('直播中')
      },
      // 查询直播状态
      async getLiveStatus() {
        let data = {
          roomId: this.roomId
        }
        const res = await getLiveStatus(data)
        console.log(res)
        try {
          if (res.data.code == 200) {
            this.liveSort = parseInt(res.data.data)
            console.log('this.liveSort='+this.liveSort+'this.liveStatus='+this.liveStatus)
            if (this.liveSort !== this.liveStatus) {
              console.log('不相同')
              this.liveStatus = this.liveSort
              this.reload()
            } else {
              console.log('相同')
            }
          }
        } catch (error) {
          console.log('已经断网')
        }
      },
      // 直播状态
      getLiveSort(type) {
        let that = this
        if (type==1) {
          clearInterval(this.giveTimer2)
          that.isEndTime = false;
          that.isStarTime = false;
          that.isVideo1 = true;
          that.timePlayUri = that.httpLive
          that.picurl = that.coverImg;
          that.livePlayer(2)
          console.log('直播中')
          that.giveTimer1 = setInterval(that.getLiveStatus,30000)
        } else if (type==2) {
          if (that.forenoticeVideo) {
            that.isEndTime = false;
            that.isStarTime = false;
            that.isVideo1 = true;
            that.timePlayUri = that.forenoticeVideo;
            that.picurl = that.forenoticeImg;
            that.livePlayer(1)
          } else {
            that.isStarTime = true;
            that.isEndTime = false;
            that.isVideo1 = false;
            // that.liveStr = '即将直播' + that.liveBeginTime
            that.picture = that.coverImg;
          }
          console.log('即将直播')
          that.giveTimer2 = setInterval(that.getLiveStatus,30000)
        } else if (type==3) {
          clearInterval(this.giveTimer3)
          that.isEndTime = false;
          that.isStarTime = false;
          that.isVideo1 = true;
          that.timePlayUri = that.playbackUrl;
          that.picurl = that.coverImg;
          that.livePlayer(1)
          console.log('直播完, 回放中')
        } else if (type==4) {
          clearInterval(this.giveTimer1)
          that.isEndTime = false;
          that.isStarTime = true;
          that.isVideo1 = false;
          that.picture = that.coverImg;
          that.liveStr = '直播结束，等待上传视频'
          console.log('已直播完, 没有回放')
          that.giveTimer3 = setInterval(that.getLiveStatus,30000)
        }
      },
      // 打开APP
      openApp() {
        window.location = 'http://t.cn/Aijv8II4'
      },
      // 点击登录注册
      submit() {
        console.log('1111111111')
        let that = this
        let reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
        if (that.phone == '') {
          that.$createToast({
            txt: '请输入手机号',
            type: 'error'
          }).show()
          console.log('1111111111')
          return
        } else if (!reg.test(that.phone)) {
          that.$createToast({
            txt: '请输入正确手机号',
            type: 'error'
          }).show()
          return
        } else if (that.code == '') {
          that.$createToast({
            txt: '请输入验证码',
            type: 'error'
          }).show()
          return
        } else {
          this.smslogin()
          console.log('tijiao')
        }
      },
      // 倒计时
      isTimeCode() {
        let that = this
        that.disabled = true
        that.timer = setInterval(function(){
          that.count--;
          if (that.count >= 0) {
            that.telstr = that.count + "秒";
          } else {
            that.telstr = '重新发送'
            that.disabled = false
            clearInterval(that.timer); // 清除定时器
            that.count = 60;
          }
        },1000);
      },
      // Java获取短信验证码
      async sendVerifcode() {
        console.log(111111)
        let that = this
        let reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
        if (that.phone == '') {
          that.$createToast({
            txt: '请输入手机号',
            type: 'error'
          }).show()
          return
        } else if (!reg.test(that.phone)) {
          that.$createToast({
            txt: '请输入正确手机号',
            type: 'error'
          }).show()
          return
        }
        that.isTimeCode()
        let data = {
          cuPhone: that.phone,
          sysCode: 'zkmsy',
          cpmType: 1,
        }
        const res = await getUserSendCode(data)
        console.log(res)
        try {
          if (res.data.code === 200) {
            that.$createToast({
              txt: '短信发送成功',
              type: 'correct'
            }).show()
          } else {
            that.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // Java注册登录会员
      async smslogin() {
        let data = {
          cuPhone: this.phone,
          msgCode: this.code,
        };
        const res = await zkmsyPhonelogin(data)
        console.log(res)
        try {
          if (res.data.code === 200) {
            this.token = res.data.data
            localStorage.setItem('uToken', res.data.data)
            // this.devotecode()
            this.getTokenlogin()
            // console.log(2222222)
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // Java获取用户信息
      async devotecode() {
        const res = await getUserInfo()
        console.log(res)
        try {
          if (res.data.code === 200) {
            this.getTokenlogin()
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
      // phython获取用户信息
      async getTokenlogin(token) {
        let data = {
          syscode: 'zkmsy',
          utoken: this.token,
          accessPort: 'h5',
          reg_form: 'applet'
        }
        const res = await tokenlogin(data)
        console.log(res)
        try {
          if (res.data.code === 1) {
            this.userId = res.data.obj[0].user_id
            localStorage.setItem('userId', this.userId)
            this.url = wechaturl + 'liveBroadcast?share_user_id='+this.userId+'&roomId='+this.roomId
            this.showLogin = false
            this.getLiveShareInc(this.userId)
            let videodesc = '授课人：'+this.anchorName+'\r\n直播时间：'+this.liveBeginTime
            wxshare(this.shareImg,this.liveTitle,videodesc,this.url);
            this.$createToast({
              txt: '登录成功',
              type: 'correct'
            }).show()
          } else {
            this.$createToast({
              txt: res.data.msg,
              type: 'error'
            }).show()
          }
        } catch (error) {}
      },
    }
  }
</script>

<style lang="scss">
  .home {
    max-width: 768px;
    margin: 0 auto;
  }
  .van-field__label {
    width: 4em;
  }
  .prism-player {
    z-index: 1;
  }
  .prism-info-display {
    padding: 0!important;
  }
  // .prism-controlbar {
  //   display: none !important;
  // }
  .prism-big-play-btn {
    left: 50%!important;
    top: 50%!important;
    margin-left: -32px!important;
    margin-top: -32px!important;
  }
  .prism-player .prism-liveshift-progress .prism-progress-cursor, .prism-player .prism-progress .prism-progress-cursor {
    border: 0 !important;
  }
  .van-overlay {
    z-index: 2;
    // top: 30px;
  }
  .van-tab {
    color: #818181;
  }
  .van-tab--active {
    color: #127BE4;
    font-weight: bold !important;
  }
  .van-tabs__line {
    width: 70px;
    background-color: #127BE4;
  }
  .liveB {
    position: relative;
    height: 2.2rem;
    background: #000;
    .all {
      position: absolute;
      width: 100%;
      height: 0.4rem;
      line-height: 0.4rem;
      text-align: left;
      bottom: 0px;
      right: 0px;
      z-index: 3;
      font-size: 0;
      background: rgba(0,0,0, 0.5);
      span {
        margin-left: 0.1rem;
        font-size: 0.14rem;
        font-weight: 500;
        color: #fff;
      }
    }
    .videobox {
      height: 2.2rem;
      z-index: 2;
    }
  }
  .entTime{
    width: 100%;
    height: 2.2rem;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 100%;
      height: 2.2rem;
    }
    .cover-over {
      width: 100%;
      height: 2.2rem;
      line-height: 2.2rem;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba($color: #000000, $alpha: 0.6);
      span {
        font-size: 0.14rem;
        font-weight: 600;
        color: #fff;
        letter-spacing: 0.03rem;
      }
    }
  }
  .warp{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .live-personal-info {
    display: flex;
    padding: 0.1rem 0;
    background: #000;
    font-size: 0;
    .personal-info-img {
      flex: 0 0 1.4rem;
      height: 0.3rem;
      line-height: 0.3rem;
      align-items: center;
      text-align: left;
      img {
        margin: 0 0.1rem;
        width: 0.3rem;
        height: 0.3rem;
        border-radius: 50%;
        vertical-align: middle;
      }
      span {
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: left;
        color: #ffffff;
        vertical-align: middle;
      }
      strong {
        margin: 0 0.1rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
      }
    }
    .personal-info-time {
      flex: 1;
      align-items: center;
      margin-right: 0.1rem;
      font-size: 0.12rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: right;
      color: #ffffff;
      .info-time-text {
        display: inline-block;
        margin-top: 0.1rem;
        padding-right: 0.05rem;
        img {
          margin-right: 0.05rem;
          width: 0.1rem;
          height: 0.08rem;
          vertical-align: middle;
        }
        span {
          vertical-align: middle;
        }
      }
      .info-time-num {
        display: inline-block;
        padding-left: 0.05rem;
        vertical-align: middle;
        border-left: 0.01rem solid #fff;
      }
    }
  }
  .live-details {
    // margin-top: 0.1rem;
    padding-top: 0.15rem;
    .live-details-button {
      font-size: 0;
      padding: 0.15rem 0.15rem 0 0.15rem;
      background: #fff;
      .msgbox-botton {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 0.45rem;
        background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
        border-radius: 0.04rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 0.45rem;
        strong {
          margin-left: 0.2rem;
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .app-button {
        width: 3.5rem;
        height: 0.45rem;
        line-height: 0.45rem;
        opacity: 1;
        background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
        border-radius: 0.04rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
      }
    }
    .live-details-title {
      padding: 0.15rem;
      background: #fff;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      text-align: left;
      color: #333333;
    }
    .live-details-info {
      display: flex;
      padding: 0 0.15rem 0.15rem 0.15rem;
      background: #fff;
      font-size: 0;
      .details-info-img {
        flex: 0 0 0.4rem;
        align-self: center;
        img {
          width: 0.4rem;
          height: 0.4rem;
          border-radius: 50%;
        }
      }
      .details-info-text {
        flex: 1;
        align-self: center;
        padding-left: 0.05rem;
        .info-text-name {
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: bold;
          text-align: left;
          color: #242424;
        }
        .info-text-list {
          padding-top: 0.06rem;
          font-size: 0.1rem;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
      }
      .details-info-button {
        flex: 0 0 0.58rem;
        align-self: center;
        .follow-msgbox-botton {
          position: relative;
          display: inline-block;
          width: 0.58rem;
          height: 0.25rem;
          background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
          border-radius: 0.15rem;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: 500;
          text-align: center;
          color: #ffffff;
          line-height: 0.25rem;
          strong {
            margin-left: 0.2rem;
          }
          .launch-btn {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
            opacity: 0;
          }
        }
        .follow-button {
          width: 0.58rem;
          height: 0.25rem;
          border-radius: 0.15rem;
          line-height: 0.25rem;
          text-align: center;
          font-size: 0.12rem;
          color: #fff;
          background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
        }
      }
    }
    .live-details-notice {
      margin-top: 0.1rem;
      padding: 0.15rem;
      background: #fff;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      text-align: left;
      color: #242424;
    }
    .live-details-account {
      padding: 0.15rem;
      background: #fff;
      font-size: 0;
      text-align: left;
      img {
        width: 0.2rem;
        height: 0.2rem;
        vertical-align: middle;
      }
      span {
        margin-left: 0.06rem;
        font-size: 0.15rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: bold;
        text-align: left;
        color: #333333;
        vertical-align: middle;
      }
    }
    .live-details-content {
      padding: 0 0.15rem 0.15rem 0.15rem;
      background: #fff;
      font-size: 0;
      p {
        padding-bottom: 0.1rem;
        font-size: 0.12rem;
        line-height: 0.2rem;
        text-align: left;
      }
      .roomdescimg {
        img {
          width: 100%;
        }
      }
    }
  }
  .share-billboard {
    // margin-top: 0.1rem;
    padding: 0.15rem 0 0;
    .live-details-button {
      font-size: 0;
      padding: 0.15rem 0.15rem 0 0.15rem;
      background: #fff;
      .msgbox-botton {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 0.45rem;
        background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
        border-radius: 0.04rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
        line-height: 0.45rem;
        strong {
          margin-left: 0.2rem;
        }
        .launch-btn {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
          opacity: 0;
        }
      }
      .app-button {
        width: 3.5rem;
        height: 0.45rem;
        line-height: 0.45rem;
        opacity: 1;
        background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
        border-radius: 0.04rem;
        font-size: 0.14rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #ffffff;
      }
    }
    .share-billboard-empty {
      padding: 1rem 0;
      text-align: center;
      background: #fff;
      img {
        width: 1.3rem;
        height: 1rem;
      }
    }
    .share-billboard-list {
      padding: 0 0.15rem;
      font-size: 0;
      background: #fff;
      .share-billboard-box {
        display: flex;
        padding: 0.15rem 0;
        border-bottom: 0.01rem solid  #f5f5f5;
        .billboard-box-img {
          flex: 0 0 0.3rem;
          padding-right: 0.1rem;
          align-self: center;
          img {
            width: 0.3rem;
            height: 0.3rem;
          }
          span {
            font-size: 0.12rem;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            text-align: center;
            color: #999999;
          }
        }
        .billboard-box-info {
          flex: 1;
          display: flex;
          align-self: center;
          .box-info-img {
            flex: 0 0 0.4rem;
            align-self: center;
            padding-right: 0.1rem;
            img {
              width: 0.4rem;
              height: 0.4rem;
              border-radius: 50%;
            }
          }
          .box-info-text {
            flex: 1;
            align-self: center;
            .info-text-title {
              text-align: left;
              span {
                padding-right: 0.1rem;
                font-size: 0.14rem;
                font-family: PingFangSC, PingFangSC-Regular;
                font-weight: 400;
                color: #181818;
                vertical-align: middle;
              }
              img {
                width: 0.68rem;
                height: 0.18rem;
                vertical-align: middle;
              }
            }
            .info-text-region {
              margin-top: 0.02rem;
              font-size: 0.14rem;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: left;
              color: #999999;
            }
          }
        }
        .billboard-box-text {
          flex: 0 0 1rem;
          align-self: center;
          font-size: 0.12rem;
          font-family: PingFangSC, PingFangSC-Medium;
          font-weight: bold;
          text-align: right;
          color: #127be4;
        }
      }
    }
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .showlogin {
      width: 3rem;
      border-radius: 0.1rem;
      overflow: hidden;
      background: #fff;
      .login-title {
        padding: 0.15rem 0;
        font-size: 0.14rem;
        font-weight: bold;
        color: #333;
      }
      .login-box {
        padding-bottom: 0.1rem;
      }
      .login-button {
        border-top: 0.01rem solid #eee;
        padding: 0.15rem 0;
        font-size: 0.14rem;
        color: #127BE4;
      }
    }
  }

</style>
